var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('container',{staticClass:"padding-top-4x"},[_c('h1',{staticClass:"align-center"},[_vm._v("Volunteer Opportunity Application Form")]),_c('volunteer-opportunities-submission-form')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }